import { createReducer, on } from "@ngrx/store";
import { EstruturaRetornoDadosOutputDto } from "src/app/domain/DTOs/output/estrutura-retorno-dados.output.dto";
import { ObterUltimaEdicaoECalendarioOutputDto } from "src/app/domain/DTOs/output/jornal/ultima-edicao-e-calendario-para-home-output.dto";
import { obterUltimaEdicaoECalendario, obterUltimaEdicaoECalendarioFinish, obterUltimaEdicaoECalendarioSuccess } from "../../actions/Jornal/obter-ultima-edicao-e-calendario-para-home.action";

export interface ObterUltimaEdicaoECalendarioState {
    response: EstruturaRetornoDadosOutputDto<ObterUltimaEdicaoECalendarioOutputDto> | null;
    error: string[] | null;
}

export const initialState: ObterUltimaEdicaoECalendarioState = {
    response: null,
    error: null,
};

export const ObterUltimaEdicaoECalendarioReducer = createReducer(
    initialState,
    on(obterUltimaEdicaoECalendario, state => ({ ...state, error: null })),
    on(obterUltimaEdicaoECalendarioSuccess, (state, { response }) => ({ ...state, response, error: null })),
    on(obterUltimaEdicaoECalendarioFinish, state => ({ ...state, response: null, error: null }))
);
